<template>
    <div class="container my-3">
        <div class="row align-items-center alert-light rounded">
            <div class="py-3 col-12">
                <div class="row">
                    <div class="col-md-5 col-lg-4 px-2">
                        <div class="form-group">
                            <required /> <label>Documento</label>
                            <div class="input-group w-100">
                                <input :class="{'is-invalid': errors.has('Documento')}"
                                    v-model="dados.selected.documento" @keypress.enter="searchCnpj"
                                    v-mask="['###.###.###-##','##.###.###/####-##']" placeholder="Insira o CPF/CNPJ"
                                    class="form-control" v-validate="{required: true}" name="Documento">
                                <span class="input-group-btn">
                                    <button @click="searchCnpj" class="btn btn-default px-md-2"
                                        :disabled="dados.selected.documento && (dados.selected.documento).length!=18"
                                        :class="{'btmerror': errors.has('Documento')}">
                                        <i class="fa"
                                            :class="(isLoadingCnpj) ? 'fa-circle-o-notch fa-spin' : 'fa-search'"></i>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-7 col-lg-8 px-2">
                        <div class="form-group">
                            <required /> <label>Nome</label>
                            <input :class="{'is-invalid': errors.has('Nome'),'is-valid': errors.has('Nome')}"
                                v-model="dados.selected.fantasia" placeholder="Insira o nome" class="form-control"
                                v-validate="{required: true}" name="Nome">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 px-2">
                        <div class="form-group">
                            <required /> <label>CEP</label>
                            <div class="input-group">
                                <input :class="{'is-invalid': errors.has('CEP')}" v-model="dados.selected.cep"
                                    @keypress.enter="searchZip" v-mask="['##.###-###']" placeholder="Insira o Cep"
                                    class="form-control" v-validate="{required: true}" name="CEP">
                                <span class="input-group-btn">
                                    <button @click="searchZip" class="btn btn-default px-md-2"
                                        :class="{'btmerror': errors.has('CEP')}">
                                        <i class="fa"
                                            :class="(isLoadingCep) ? 'fa-circle-o-notch fa-spin' : 'fa-search' "></i>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 px-2">
                        <div class="form-group">
                            <label>Endereço</label>
                            <input :class="{'is-invalid': errors.has('Endereco')}" v-model="dados.selected.endereco"
                                placeholder="Insira o endereço" class="form-control" v-validate="{required: true}"
                                name="Endereco">
                        </div>
                    </div>
                    <div class="col-md-2 px-2">
                        <div class="form-group">
                            <label>Nº</label>
                            <input id="Nro" :class="{'is-invalid': errors.has('Numero')}"
                                v-model="dados.selected.numero" placeholder="Insira o numero" class="form-control"
                                v-validate="{required: true}" name="Numero">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 px-2">
                        <div class="form-group">
                            <required /> <label>Bairro</label>
                            <input :class="{'is-invalid': errors.has('Bairro')}" v-model="dados.selected.bairro"
                                placeholder="Bairro" class="form-control" v-validate="{required: true}" name="Bairro">
                        </div>
                    </div>
                    <div class="col-md-4 px-2">
                        <div class="form-group">
                            <required /> <label>Estado</label>
                            <select :class="{'is-invalid': errors.has('Estado')}"
                                @change="getCidades(dados.selected.estado)" v-model="dados.selected.estado"
                                placeholder="Bairro" class="form-control" v-validate="{required: true}" name="Estado">
                                <option :value="null">{{$t('words.select')}}</option>
                                <option v-for="(item, i) in estados" :value="item.id" :key="i">
                                    {{item.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4 px-2">
                        <div class="form-group">
                            <required /> <label>Cidade</label>
                            <select :class="{'is-invalid': errors.has('Cidade')}" v-model="dados.selected.cidade"
                                @change="getCidadeName()" class="form-control" v-validate="{required: true}"
                                name="Cidade">
                                <option :value="null">{{$t('words.select')}}</option>
                                <option v-for="(item, i) in cidades" :value="item.id" :key="i">{{item.name}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="dados.selected.smart">
                    <div class="col-md-3 px-2">
                        <div class="form-group">
                            <label>CNAE:</label>
                            <input v-model="dados.selected.cnae" name="cnae" class="form-control" placeholder="CNAE"
                                mask="##.##-#-##">
                        </div>
                    </div>
                    <div class="col-md-9 px-2">
                        <div class="form-group">
                            <label>Descrição CNAE:</label>
                            <input v-model="dados.selected.cnaeName" name="cnaeNome" class="form-control"
                                placeholder="Descrição CNAE">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 px-2">
                        <div class="form-group">
                            <label>Complemento</label>
                            <input v-model="dados.selected.complemento" name="Complemento" class="form-control"
                                placeholder="Complemento (Opcional)">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 d-flex text-justify pt-4 px-md-5 pb-0" @click="validate">
                        <required class="pr-2 pr-md-3" /> <input type="checkbox" id="checkbox" v-validate="{required: true}"
                            name="Cookies">
                        <label class="pl-2 pl-md-3" for="checkbox" :class="{'text-red': errors.has('Cookies')}"> Nós usamos
                            cookies e outras tecnologias semelhantes para melhorar a sua experiência em nossos serviços.
                            Ao utilizar nossos serviços, você concorda com tal monitoramento. Conheça nossa <router-link
                                to="/dicas" target="_blank">Politica de utilização de Cookies </router-link>
                            .</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['dados'],
        inject: ['$validator'],
        data() {
            return {
                isLoadingCnpj: false,
                isLoadingCep: false,
                documento: true,
                cidades: [],
            }
        },
        beforeMount() {
            if (!this.estados.length) {
                this.$store.dispatch('getEstados');
            }
        },
        watch: {
            'empresa.emp_uf': function (data) {
                this.getCities();
            }
        },
        methods: {
            resetCity() {
                if (this.cidades.findIndex(item => item.id == this.dados.selected.cidade) == -1) {
                    this.dados.selected.cidade = null;
                }
                this.getEstadoUf();
            },
            getEstadoUf() {
                if (!this.dados.selected.estado) {
                    return;
                }
                this.dados.selected.uf = this.estados.find(x => x.id == this.dados.selected.estado).uf;
            },
            getCidadeName() {
                this.dados.selected.nomeCidade = this.cidades.find(x => x.id == this.dados.selected.cidade).name;
            },
            searchCnpj() {
                if ((this.isValidCnpj(this.dados.selected.documento)) && (this.documento == true)) {
                    this.isLoadingCnpj = true;
                    service
                        .searchCnpj(this.dados.selected.documento)
                        .then(response => {
                            this.dados.selected.fantasia = response.nome
                            this.dados.selected.cep = response.cep
                            this.dados.selected.numero = response.numero
                            this.dados.selected.complemento = response.complemento
                            this.dados.selected.cnae = response.atividade_principal[0].code
                            this.dados.selected.cnaeName = response.atividade_principal[0].text
                            this.isLoadingCnpj = false;
                            if (response) {
                                this.searchZip()
                            }
                        })
                        .catch(error => {
                            this.isLoadingCnpj = false;
                        });
                } else {
                    this.dados.selected.fantasia = ''
                    this.dados.selected.cep = ''
                    this.dados.selected.endereco = ''
                    this.dados.selected.numero = ''
                    this.dados.selected.bairro = ''
                    this.dados.selected.estado = null
                    this.dados.selected.cidade = null
                    this.dados.selected.complemento = ''
                }
            },
            searchZip() {
                if (this.dados.selected.cep != undefined) {
                    this.isLoadingCep = true;
                    service
                        .searchZip(this.dados.selected.cep)
                        .then(response => {
                            this.isLoadingCep = false;
                            if (response.uf !== undefined) {
                                this.dados.selected.endereco = response.logradouro
                                this.dados.selected.bairro = response.bairro
                                this.dados.selected.estado = response.ibge.substring(0, 2);
                                this.dados.selected.cidade = response.ibge
                                this.dados.selected.nomeCidade = response.localidade;
                                this.dados.selected.uf = response.uf;
                                this.getCidades(this.dados.selected.estado, this.dados.selected.ibge);
                                $('#Nro').focus();
                                this.validate()
                            }
                        })
                        .catch(error => {
                            this.isLoadingCep = false;
                            this.dados.selected.endereco = ''
                            this.dados.selected.bairro = ''
                            this.dados.selected.estado = null
                            this.dados.selected.cidade = null
                        });
                }
            },
            validate() {
                return this.$validator.validateAll().then(valid => {
                    return valid;
                });
            },
        }
    }
</script>

<style scoped src="@/assets/sass/bootstrap4.css"></style>
<style scoped src="@/assets/sass/home.css"></style>
<style scoped lang="scss" src="./register.scss"></style>

<style scoped>
    .btmerror {
        border-top: 1px solid red;
        border-bottom: 1px solid red;
        border-right: 1px solid red;
    }
</style>